export const DO_VIDEO_REQUEST = 'DO_VIDEO_REQUEST';
export const DO_VIDEO_SUCCESS = 'DO_VIDEO_SUCCESS';
export const DO_VIDEO_FAILURE = 'DO_VIDEO_FAILURE';

export const RESET_VIDEO_STATE = 'RESET_VIDEO_STATE';

export const DO_TRACK_VIDEO_EVENT_REQUEST = 'DO_TRACK_VIDEO_EVENT_REQUEST';

export const UPDATE_PLAYBACK_TIME = 'UPDATE_PLAYBACK_TIME';
